export const GET_DAA_PRINT_CHECK = "GET_DAA_PRINT_CHECK";
export const SET_KITCHEN_SHIFT_STATUS = "SET_KITCHEN_SHIFT_STATUS";
export const SET_KITCHEN_SHIFT_LOADING = "SET_KITCHEN_SHIFT_LOADING";